import CircleInfoIcon from '@/app/assets/svg/circle-info.svg?react';
import { cn } from '@/app/shared/lib/cn';

interface SwapAlertProps {
  message: React.ReactNode;
  variant?: 'warning' | 'error';
  compact?: boolean;
}

export const SwapAlert = ({ message, variant = 'warning', compact = false }: SwapAlertProps) => {
  const isError = variant === 'error';

  return (
    <div
      className={cn(
        'flex items-center gap-3',
        compact
          ? 'gap-2'
          : cn('rounded-md border p-4', isError ? 'border-red-700/30 bg-red-500/10' : 'border-gray-700/30 bg-gray-800/50'),
      )}
    >
      <CircleInfoIcon
        className={cn('h-5 w-5 shrink-0', isError ? 'text-feedback-error' : 'text-status-unlocking')}
      />
      <p className={cn('text-sm', isError ? 'text-feedback-error' : 'text-gray-300')}>{message}</p>
    </div>
  );
};
